import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface DoubleLeftChevronIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const DoubleLeftChevronIcon: React.FC<DoubleLeftChevronIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon double-left-chevron')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512">
        <path d="M73.22 256l160.1-167.4c9.125-9.594 8.844-24.78-.75-33.94S207.8 45.84 198.7 55.4l-176 184c-8.875 9.313-8.875 23.88 0 33.19l176 184c9.156 9.563 24.34 9.907 33.94 .75C237.5 452.6 240 446.3 240 440c0-5.969-2.219-11.94-6.656-16.59L73.22 256zM425.3 423.4L265.2 256l160.1-167.4c9.125-9.594 8.844-24.78-.75-33.94s-24.78-8.813-33.94 .75l-176 184c-8.875 9.313-8.875 23.88 0 33.19l176 184c9.156 9.563 24.34 9.907 33.94 .75C429.5 452.6 432 446.3 432 440C432 434 429.8 428.1 425.3 423.4z" />
      </svg>
    </Tooltip>
  );
};
